/**
 * Returns whether a minutes motion has non-empty rich-text body content.
 */
export const hasMinutesMotionText = (motionText) => !!motionText && motionText.replace(/<[^>]*>/g, '').trim().length > 0;
/**
 * Returns whether a motion has no mover, seconder, or motion text recorded.
 */
export const isBareMinutesMotion = (motion) => {
    const hasMover = motion.moverId != null || motion.mover != null;
    const hasSeconder = motion.seconderId != null || motion.seconder != null;
    return !hasMover && !hasSeconder && !hasMinutesMotionText(motion.motionText);
};
/**
 * Returns whether a motion represents a consent-calendar outcome with no
 * recorded vote rows — surfaced in the UI as a vote-style item record only.
 */
export const isConsentOutcomeMotion = (motion) => {
    if (motion.voteOrderById == null) {
        return false;
    }
    if (motion.resultLegislativeStatusId == null && motion.resultLegislativeStatus == null) {
        return false;
    }
    if ((motion.votes ?? []).length > 0) {
        return false;
    }
    return isBareMinutesMotion(motion);
};
/**
 * Returns whether a motion is an auto-seeded recommended-action placeholder the clerk has not
 * acted on yet. When minutes are created, every agenda item is pre-seeded with a `main` motion
 * carrying the recommended-action text but no mover, seconder, vote slot, result, or votes. These
 * belong in the minutes editor (as a pre-filled card) but must NOT appear in the live chronological
 * timeline until actually recorded. Privileged and subsidiary motions are always created
 * deliberately and so are never treated as seeds.
 */
export const isUnrecordedSeedMotion = (motion) => {
    if (motion.legislativeAction?.type !== 'main') {
        return false;
    }
    const hasMover = motion.moverId != null || motion.mover != null;
    const hasSeconder = motion.seconderId != null || motion.seconder != null;
    const hasVoteSlot = motion.voteOrderById != null;
    const hasResult = motion.resultLegislativeStatusId != null || motion.resultLegislativeStatus != null;
    const hasVotes = (motion.votes ?? []).length > 0;
    return !hasMover && !hasSeconder && !hasVoteSlot && !hasResult && !hasVotes;
};
